<template>
  <div class="shock-reflection-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Mach Reflection | 规则反射与马赫反射$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Wall (Ground) -->
          <line x1="0" y1="200" x2="400" y2="200" stroke="#888" stroke-width="2" />
          
          <!-- Incident Shock -->
          <line :x1="80" :y1="200 - h" :x2="200" y2="200" stroke="#ff4757" stroke-width="3" opacity="0.8" />
          
          <!-- Reflected Shock (Regular) -->
          <line v-if="!isMach" :x1="200" y1="200" :x2="320" :y2="200 - h" stroke="#ffd700" stroke-width="3" opacity="0.8" />

          <!-- Mach Stem and Triple Point (Mach Reflection) -->
          <g v-else>
             <!-- Triple point -->
             <circle :cx="200" :cy="200 - machHeight" r="4" fill="#fff" />
             <!-- Mach Stem (Vertical) -->
             <line :x1="200" :y1="200 - machHeight" :x2="200" y2="200" stroke="#00d2ff" stroke-width="4" />
             <!-- Reflected Shock -->
             <path :d="`M 200,${200 - machHeight} Q 250,${200 - machHeight - 10} 350,100`" fill="none" stroke="#ffd700" stroke-width="3" />
             <text :x="210" :y="200 - machHeight/2" fill="#00d2ff" font-size="8">马赫杆</text>
          </g>

          <!-- Source -->
          <circle cx="80" :cy="200 - h" r="5" fill="#ff4757" />
          
          <text x="10" y="30" fill="#888" font-size="8">入射波</text>
          <text x="300" y="30" fill="#ffd700" font-size="8">反射波</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>反射类型: {{ isMach ? '马赫反射 (强非线性)' : '规则反射' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>入射角</label>
             <el-slider v-model="angle" :min="10" :max="60" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当激波撞击固体表面时，会发生复杂的反射。当入射角较小时，波能直接弹开，称为**规则反射**。但当角度变大或流动达到一定马赫数时，由于非线性压缩，反射波无法在壁面上形成，而是会在半空中与入射波交汇，产生一个垂直于壁面的强激波——**马赫杆**。这在核爆炸地面破坏分析、超音速进气道设计以及爆炸力学中至关重要。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShockWaveReflectionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      angle: 30
    }
  },
  computed: {
    h() { return 100; },
    isMach() { return this.angle > 40; },
    machHeight() {
       return (this.angle - 40) * 3;
    }
  }
}
</script>

<style scoped lang="scss">
.shock-reflection-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
